// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3029":"css/admin-app.6726","7570":"css/app.6726"}[chunkId] + ".css";
};